import { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';

// @todo Handle tabs duplication
export function useTabId() {
  const [tabId, setTabId] = useState<string | null>(null);

  useEffect(() => {
    let currentTabId = sessionStorage.getItem('tabId');

    if (!currentTabId) {
      currentTabId = nanoid(6);
      sessionStorage.setItem('tabId', currentTabId);
    }

    setTabId(currentTabId);
  }, []);

  return tabId;
}
